import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { StepIds } from '../../../../models/property-step/property-step-model';
import { DraftFacade } from '@classifieds-sell/state';
import { PropertySectionBase } from '../../../property-section-base';

@Component({
    selector: 'property-summary-page-property-description-section',
    templateUrl: './summary-page-property-description-section.component.html',
    styleUrls: ['./summary-page-property-description-section.component.scss']
})
export class ResidentialForSaleSummaryPagePropertyDescriptionSectionComponent
    extends PropertySectionBase
    implements OnInit, OnDestroy {
    stepIds = StepIds;

    listingTitle: string;
    amenities: string;

    private _destroyed$: Subject<void> = new Subject<void>();

    constructor(
        draftFacade: DraftFacade,
        private _changeDetectorRef: ChangeDetectorRef
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.listingTitle = this.draftData.propertyDescription.title;
            this.amenities = this.draftData.propertyDescription.amenities;
            this._changeDetectorRef.markForCheck();
        });
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return false;
    }
}
